import { RFIconProps } from "../types";

export default function DayIcon(props: RFIconProps) {
	return (
		<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M6.99996 9.76677C8.80417 9.76677 10.2668 8.30417 10.2668 6.49996C10.2668 4.69575 8.80417 3.23315 6.99996 3.23315C5.19575 3.23315 3.73315 4.69575 3.73315 6.49996C3.73315 8.30417 5.19575 9.76677 6.99996 9.76677Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M7 0.5V1.4384" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M2.75952 2.25952L3.42227 2.92227" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M1 6.5H1.9384" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M2.75952 10.7462L3.42227 10.0835" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M7 12.5V11.5675" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M11.2462 10.7462L10.5835 10.0835" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M13 6.5H12.0675" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M11.2462 2.25952L10.5835 2.92227" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
}
